/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "../../../../../components/Container/Container";
import AttorneySection from "../../../../../components/Sections/Divorce/DivorceAttorneySection/AttorneySection";
import LpContractAdvocardMeta from "./LpContractAdvocardMeta";
import HowItWorksSection from "../../../../../components/Sections/Contract/HowItWorksSection/HowItWorksSection";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "../../../../../services/landingPageService";
import SpecialEnergyContractCheckin
  from "../../../../../components/Checkin/ContractCheckin/SpecialEnergyContractCheckin";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";

const LpSpecialEnergyCasesAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpContractAdvocardMeta />
      <LandingPageTeaser
        teaserButtonText={"Jetzt Starten"}
        headline={"Advocard Energie-Hilfe: Probleme mit Ihrem Anbieter?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerName={"advocard"} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <SpecialEnergyContractCheckin idPrefix={"top"} partner={"advocard"} />
          </Container>
        )}
        <HowItWorksSection />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={
          "Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"
        }
      />

      <TrustSection />
      {!isLoggedIn && (
        <GreyBackgroundWrapper>
          <Container>
            <SpecialEnergyContractCheckin idPrefix={"bottom"} partner={"advocard"} />
          </Container>
        </GreyBackgroundWrapper>
      )}
    </Layout>
  );
};

export default LpSpecialEnergyCasesAdvocard;
